import { DatePickerInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import classNames from "classnames";
import dayjs from "dayjs";
import type { CSSProperties } from "react";

import styles from "./DateInput.module.scss";

interface DateInputProps {
  id: string;
  value: string;
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  textStyle?: CSSProperties;
  className?: string;
  onChange: (value: string) => void;
  // Mantine styles overrides
  variant?: string;
  forwardDate?: boolean;
}

export function DateInput({
  id,
  value,
  readonly,
  className,
  onChange,
  textStyle,
  variant,
  forwardDate = true,
}: DateInputProps) {
  let maxDate: Date | undefined;

  if (!forwardDate) {
    maxDate = new Date();
  }

  return (
    <DatePickerInput
      id={id}
      className={classNames(
        styles.input,
        readonly && styles.readonly,
        className,
      )}
      maxDate={maxDate}
      valueFormat="DD MMM YYYY"
      readOnly={!!readonly}
      dropdownType="popover"
      variant={variant}
      rightSection={<IconCalendar size={16} />}
      styles={{
        input: {
          fontSize: "inherit",
          color: "inherit",
          ...(textStyle as any),
        },
      }}
      popoverProps={{
        position: "bottom-start",
        withinPortal: true,
        zIndex: 1000,
      }}
      value={value ? new Date(value) : null}
      onChange={date => {
        if (date) {
          onChange(dayjs(date).format("YYYY-MM-DD"));
        } else {
          onChange("");
        }
      }}
    />
  );
}
